import { render, staticRenderFns } from "./TermosDeUso.vue?vue&type=template&id=4be74490"
import script from "./TermosDeUso.vue?vue&type=script&lang=ts"
export * from "./TermosDeUso.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports